import * as React from "react";
import { SvgProps } from "../../../utils/interfaces";

const WarningOutlineSvg: React.FC<SvgProps> = ({
  width,
  height,
  viewBox = "6.5 37 67 1",
  color = "#236998",
  ...rest
}) => {
  return (
    <svg width={width} height={height} viewBox={viewBox} fill="none" {...rest}>
      <path
        d="M15.0364 70.2544H64.9635C70.1854 70.2544 73.3333 66.6049 73.3333 61.9478C73.3333 60.478 72.9103 58.9267 72.0954 57.5005L47.1225 13.8824C45.5346 11.1197 42.8 9.74527 40.0063 9.74527C37.1999 9.74527 34.4372 11.1197 32.8773 13.8824L7.90457 57.5005C7.06148 58.9548 6.66663 60.478 6.66663 61.9478C6.66663 66.6049 9.81447 70.2544 15.0364 70.2544ZM15.0771 65.8099C12.6636 65.8099 11.2207 63.9779 11.2207 61.9352C11.2207 61.216 11.4061 60.3745 11.805 59.6426L36.737 16.0218C37.4493 14.7728 38.7419 14.2304 40.0063 14.2304C41.2299 14.2304 42.4943 14.7728 43.2347 16.0218L68.1667 59.6708C68.5657 60.4026 68.7511 61.216 68.7511 61.9352C68.7511 63.9779 67.3082 65.8099 64.8946 65.8099H15.0771ZM39.9937 48.8639C41.3388 48.8639 42.1398 48.0655 42.1679 46.5575L42.5966 29.598C42.6248 28.1461 41.4736 27.0512 39.9655 27.0512C38.4012 27.0512 37.3343 28.1179 37.3625 29.5699L37.7349 46.5575C37.763 48.0375 38.5642 48.8639 39.9937 48.8639ZM39.9937 58.9968C41.7251 58.9968 43.1712 57.6252 43.1712 55.9035C43.1712 54.1567 41.7532 52.8103 39.9937 52.8103C38.2467 52.8103 36.7879 54.1848 36.7879 55.9035C36.7879 57.597 38.2749 58.9968 39.9937 58.9968Z"
        fill={color}
      />
    </svg>
  );
};

export { WarningOutlineSvg };
